module.exports = __webpack_public_path__ + "img/qr.79c557e7.png";